/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AmbienteResponse,
  AmbientesControllerListarParams,
  AtualizarAmbienteDto,
  CriarAmbienteDto,
  DefinirAtivoAmbienteDto,
  ErroResponse,
  PaginaDeAmbientesResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAmbientesControllerListarUrl = (params?: AmbientesControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/ambientes?${stringifiedParams}` : `/v1/admin/ambientes`
}

/**
 * @summary Lista os ambientes, paginado
 */
export const ambientesControllerListar = async (params?: AmbientesControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeAmbientesResponse> => {

  return httpClient<PaginaDeAmbientesResponse>(getAmbientesControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAmbientesControllerListarQueryKey = (params?: AmbientesControllerListarParams,) => {
    return [
    `/v1/admin/ambientes`, ...(params ? [params] : [])
    ] as const;
    }


export const getAmbientesControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof ambientesControllerListar>>, TError = ErroResponse>(params?: AmbientesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambientesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAmbientesControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof ambientesControllerListar>>> = ({ signal }) => ambientesControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ambientesControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AmbientesControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof ambientesControllerListar>>>
export type AmbientesControllerListarQueryError = ErroResponse


export function useAmbientesControllerListar<TData = Awaited<ReturnType<typeof ambientesControllerListar>>, TError = ErroResponse>(
 params: undefined |  AmbientesControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambientesControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ambientesControllerListar>>,
          TError,
          Awaited<ReturnType<typeof ambientesControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAmbientesControllerListar<TData = Awaited<ReturnType<typeof ambientesControllerListar>>, TError = ErroResponse>(
 params?: AmbientesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambientesControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ambientesControllerListar>>,
          TError,
          Awaited<ReturnType<typeof ambientesControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAmbientesControllerListar<TData = Awaited<ReturnType<typeof ambientesControllerListar>>, TError = ErroResponse>(
 params?: AmbientesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambientesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os ambientes, paginado
 */

export function useAmbientesControllerListar<TData = Awaited<ReturnType<typeof ambientesControllerListar>>, TError = ErroResponse>(
 params?: AmbientesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambientesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAmbientesControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAmbientesControllerCriarUrl = () => {




  return `/v1/admin/ambientes`
}

/**
 * @summary Cria um ambiente. O tipo é definido aqui e não muda depois.
 */
export const ambientesControllerCriar = async (criarAmbienteDto: CriarAmbienteDto, options?: Parameters<typeof httpClient>[1]): Promise<AmbienteResponse> => {

  return httpClient<AmbienteResponse>(getAmbientesControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarAmbienteDto)
  }
);}





export const getAmbientesControllerCriarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambientesControllerCriar>>, TError,{data: CriarAmbienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof ambientesControllerCriar>>, TError,{data: CriarAmbienteDto}, TContext> => {

const mutationKey = ['ambientesControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ambientesControllerCriar>>, {data: CriarAmbienteDto}> = (props) => {
          const {data} = props ?? {};

          return  ambientesControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AmbientesControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof ambientesControllerCriar>>>
    export type AmbientesControllerCriarMutationBody = CriarAmbienteDto
    export type AmbientesControllerCriarMutationError = unknown

    /**
 * @summary Cria um ambiente. O tipo é definido aqui e não muda depois.
 */
export const useAmbientesControllerCriar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambientesControllerCriar>>, TError,{data: CriarAmbienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ambientesControllerCriar>>,
        TError,
        {data: CriarAmbienteDto},
        TContext
      > => {
      return useMutation(getAmbientesControllerCriarMutationOptions(options), queryClient);
    }
    export const getAmbientesControllerObterUrl = (id: string,) => {




  return `/v1/admin/ambientes/${id}`
}

/**
 * @summary Detalha um ambiente
 */
export const ambientesControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<AmbienteResponse> => {

  return httpClient<AmbienteResponse>(getAmbientesControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAmbientesControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/admin/ambientes/${id}`
    ] as const;
    }


export const getAmbientesControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof ambientesControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambientesControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAmbientesControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof ambientesControllerObter>>> = ({ signal }) => ambientesControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof ambientesControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AmbientesControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof ambientesControllerObter>>>
export type AmbientesControllerObterQueryError = ErroResponse


export function useAmbientesControllerObter<TData = Awaited<ReturnType<typeof ambientesControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambientesControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof ambientesControllerObter>>,
          TError,
          Awaited<ReturnType<typeof ambientesControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAmbientesControllerObter<TData = Awaited<ReturnType<typeof ambientesControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambientesControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof ambientesControllerObter>>,
          TError,
          Awaited<ReturnType<typeof ambientesControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAmbientesControllerObter<TData = Awaited<ReturnType<typeof ambientesControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambientesControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha um ambiente
 */

export function useAmbientesControllerObter<TData = Awaited<ReturnType<typeof ambientesControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof ambientesControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAmbientesControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAmbientesControllerAtualizarUrl = (id: string,) => {




  return `/v1/admin/ambientes/${id}`
}

/**
 * @summary Renomeia. O `slug` não muda.
 */
export const ambientesControllerAtualizar = async (id: string,
    atualizarAmbienteDto: AtualizarAmbienteDto, options?: Parameters<typeof httpClient>[1]): Promise<AmbienteResponse> => {

  return httpClient<AmbienteResponse>(getAmbientesControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarAmbienteDto)
  }
);}





export const getAmbientesControllerAtualizarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambientesControllerAtualizar>>, TError,{id: string;data: AtualizarAmbienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof ambientesControllerAtualizar>>, TError,{id: string;data: AtualizarAmbienteDto}, TContext> => {

const mutationKey = ['ambientesControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ambientesControllerAtualizar>>, {id: string;data: AtualizarAmbienteDto}> = (props) => {
          const {id,data} = props ?? {};

          return  ambientesControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AmbientesControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof ambientesControllerAtualizar>>>
    export type AmbientesControllerAtualizarMutationBody = AtualizarAmbienteDto
    export type AmbientesControllerAtualizarMutationError = unknown

    /**
 * @summary Renomeia. O `slug` não muda.
 */
export const useAmbientesControllerAtualizar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambientesControllerAtualizar>>, TError,{id: string;data: AtualizarAmbienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ambientesControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarAmbienteDto},
        TContext
      > => {
      return useMutation(getAmbientesControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getAmbientesControllerDefinirAtivoUrl = (id: string,) => {




  return `/v1/admin/ambientes/${id}/ativo`
}

/**
 * @summary Ativa ou desativa. Desativar derruba todos os membros no request seguinte.
 */
export const ambientesControllerDefinirAtivo = async (id: string,
    definirAtivoAmbienteDto: DefinirAtivoAmbienteDto, options?: Parameters<typeof httpClient>[1]): Promise<AmbienteResponse> => {

  return httpClient<AmbienteResponse>(getAmbientesControllerDefinirAtivoUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(definirAtivoAmbienteDto)
  }
);}





export const getAmbientesControllerDefinirAtivoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambientesControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoAmbienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof ambientesControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoAmbienteDto}, TContext> => {

const mutationKey = ['ambientesControllerDefinirAtivo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof ambientesControllerDefinirAtivo>>, {id: string;data: DefinirAtivoAmbienteDto}> = (props) => {
          const {id,data} = props ?? {};

          return  ambientesControllerDefinirAtivo(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AmbientesControllerDefinirAtivoMutationResult = NonNullable<Awaited<ReturnType<typeof ambientesControllerDefinirAtivo>>>
    export type AmbientesControllerDefinirAtivoMutationBody = DefinirAtivoAmbienteDto
    export type AmbientesControllerDefinirAtivoMutationError = ErroResponse

    /**
 * @summary Ativa ou desativa. Desativar derruba todos os membros no request seguinte.
 */
export const useAmbientesControllerDefinirAtivo = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof ambientesControllerDefinirAtivo>>, TError,{id: string;data: DefinirAtivoAmbienteDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof ambientesControllerDefinirAtivo>>,
        TError,
        {id: string;data: DefinirAtivoAmbienteDto},
        TContext
      > => {
      return useMutation(getAmbientesControllerDefinirAtivoMutationOptions(options), queryClient);
    }
